import React, { useState, useMemo, useEffect } from "react";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import Navbar from "../../Navbar";

import EditNoteIcon from "@mui/icons-material/EditNote";
import {
  Container,
  Box,
  Typography,
  ListItemIcon,
  MenuItem,
} from "@mui/material";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import { getData } from "../../../services/library";

import moment from "moment";
import TabMotivos from "./TabMotivos";
import { logEventos } from "../../../services/services";

const MotivosTabla = () => {
  const [motivos, setMotivos] = useState([]);
  const [tabIndex, setTabIndex] = useState(1);
  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "primary",
    size: "small",
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };
  useEffect(() => {
    getData("/SP_candidatos/getAllCandidatos/motivos", (data) => {
      setMotivos(Array.isArray(data) ? data : []);
    });
  }, []);

  const columns = useMemo(() => {
    const baseColumns = [
      { header: "DNI", accessorKey: "dni", size: 50 },
      {
        header: "Nombre y apellido",
        Cell: ({ row }) => `${row.original.nombre} ${row.original.apellido}`,
        size: 60,
      },
      {
        header: "Solicitud que aplicaba",
        accessorKey: "id_solicitud_a_aplicar",
        size: 30,
      },
      {
        header: "Motivo",
        accessor: "motivo",
        Cell: ({ row }) => {
          const { motivo, estado, id_solicitud_a_aplicar, estado_solicitud } =
            row.original || {};
          return motivo
            ? motivo
            : estado === 2
            ? `Candidato seleccionado en la solicitud ${id_solicitud_a_aplicar}`
            : estado === null
            ? "Candidato oculto por decicion de recursos humanos"
            : estado === 1 && estado_solicitud === 2
            ? "El candidato tiene estado pendiente pero esta en una solicitud que ya selecciono otro candidato"
            : estado === 1 && estado_solicitud === 0
            ? "El cnadidato esta en estado pendiente en una busqueda laboral cancelada"
            : "El candidato esta en estado pendiente en una busqueda laboral activa";
        },
        size: 200,
      },
      {
        header: "Estado solicitud",
        Cell: ({ row }) =>
          row.original.estado_solicitud === 1
            ? "Pendiente"
            : row.original.estado_solicitud === 2
            ? "Finalizada"
            : "Cancelada",
        size: 0,
      },
      {
        header: "Fecha de rechazo",
        Cell: ({ row }) =>
          row.original.fecha_rechazo
            ? moment(row.original.fecha_rechazo).format("DD/MM/YYYY")
            : "-",
        size: 0,
      },
      {
        header: "Rechazado por",
        accessorKey: "user",
        size: 30,
      },
    ];

    return baseColumns;
  }, []);

  const globalTheme = useTheme();
  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: {
            main: "rgb(255,122,0)",
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)"
                : "#000",
          },
        },
        typography: {
          button: {
            textTransform: "none",
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme]
  );
  let filtredData;
  if (tabIndex === 3)
    filtredData = motivos?.filter((motivo) => motivo.estado === 2);
  else if (tabIndex === 1)
    filtredData = motivos?.filter((motivo) => motivo.motivo !== null);
  else if (tabIndex === 2)
    filtredData = motivos?.filter(
      (motivo) => motivo.motivo === null && motivo.estado === 1
    );
  else {
    filtredData = motivos?.filter(
      (motivo) => motivo.estado === null && motivo.motivo === null
    );
  }

  useEffect(() => {
    logEventos(
      "acceso al menu resumen de postulantes",
      "resumen de postulantes",
      "Lista postulantes",
      localStorage.getItem("user")
    );
  }, []);

  return (
    <>
      <Navbar />
      <TabMotivos value={tabIndex} setValue={setTabIndex} />
      <Container maxWidth={false} sx={{ width: "100%" }} mt={1}>
        {motivos ? (
          <Box mt={2} mb={4}>
            <ThemeProvider theme={tableTheme}>
              <MaterialReactTable
                autoResetPageIndex={false}
                enableGrouping
                layoutMode="grid"
                muiTableHeadCellProps={tableHeadCellProps}
                muiTableBodyCellProps={({ row }) => ({
                  align: "left",
                  sx: {
                    padding: "6px 0px", // Reduce el padding para hacerla más compacta
                    borderColor: "black",
                    backgroundColor:
                      row.original.estado === 2
                        ? "#b3e6b3"
                        : row.original.estado === 1 &&
                          row.original.motivo === null
                        ? "#fff"
                        : row.original.motivo !== null &&
                          row.original.estado === 1
                        ? "#efc3c3"
                        : "#749fe8",
                    wordWrap: "break-word",
                    whiteSpace: "wrap", // Evita que el ID se expanda demasiado
                  },
                })}
                enableColumnActions={true}
                enableColumnFilters={false}
                enableHiding={false}
                enableDensityToggle={false}
                localization={MRT_Localization_ES}
                enableColumnDragging={false}
                initialState={initialState}
                // renderDetailPanel={({ row }) => (
                //   <Container
                //     sx={{
                //       display: "flex",
                //       justifyContent: "center",
                //       alignItems: "center",
                //       margin: "auto",
                //       width: "1200px",
                //     }}
                //   >
                //     aca va el desplegable (la descreipcion)
                //   </Container>
                // )}
                muiSearchTextFieldProps={muiSearchTextFieldProps}
                columns={columns}
                data={filtredData ?? motivos ?? []}
                enableStickyFooter
                renderToolbarInternalActions={({ table }) => <></>}
                // renderTopToolbarCustomActions={() => (
                //   <Box sx={{ display: "flex" }}>
                //     <Typography
                //       variant="poster"
                //       style={{ fontSize: 26, textAlign: "center" }}
                //     >
                //       Motivos de las propuestas de rechazo por parte de los
                //       candidatos
                //     </Typography>
                //   </Box>
                // )}
              />
            </ThemeProvider>
          </Box>
        ) : null}
      </Container>
    </>
  );
};

export default MotivosTabla;
